module.exports = __webpack_public_path__ + "static/media/acceptedPayments.b2824d09.jpg";